<template>
<div class="container">

    <div class="col-md-12">
      <div class=" card d-flex align-items-center">
        <h3>Spring-Rechnungsimport</h3>
        <b-form-group>
            <b-form-file id="file-small" size="md" @change="onChange" placeholder="keine Datei ausgewählt" class="w-auto centered-file-input">
            </b-form-file>
        </b-form-group>
        <b-btn variant="primary mb-2" size="md" @click="uploadFile" :disabled="isRequestInProgress || disableImport">
          importieren <b-spinner small v-show="isRequestInProgress"></b-spinner>
        </b-btn>
      </div>
    </div>
  <b-modal v-model="showImportInfoModal" title="Import Info">
    Folgende Fehler sind aufgetreten:<br>
    <span v-for="(value, key) in importResult" :key="key">
      {{ value }} <br>
    </span>
  </b-modal>
    <modal-error-component v-model="modalError"></modal-error-component>
</div>
</template>

<script>
export default {
  name: "GeneralImport",
  data() {
    return {
      data: null,
      fileData: null,
      isRequestInProgress: false,
      importResult: null,
      showImportInfoModal: false,
      modalError: {
        show: false,
        message: "unpopulated",
        error: "unpopulated",
        title: "unpopulated"
      }
    };
  },
  computed: {
    disableImport() {
      return this.fileData == null;
    }
  },
  methods: {
    onChange(event) {
      this.file = event.target.files ? event.target.files[0] : null;
      if (this.file) {
        const reader = new FileReader();

        reader.onload = (e) => {
          /* Parse data */
          const bstr = e.target.result;
          const wb = XLSX.read(bstr, { type: 'binary' });
          /* Get first worksheet */
          const wsname = wb.SheetNames[0];
          const ws = wb.Sheets[wsname];
          /* Convert array of arrays */
           this.fileData = {
             name: this.file.name,
             data: XLSX.utils.sheet_to_json(ws, { header: 1 })
           };
        }
        reader.readAsBinaryString(this.file);
      }
    },
    uploadFile() {
      this.isRequestInProgress = true;
      axios.post('/generalimport/spring', {fileData: this.fileData})
      .then(response => {
        this.isRequestInProgress = false;
        if(response.data) {
          this.importResult = response.data;
          this.showImportInfoModal = true;
        }
        this.$bvToast.toast('Daten wurden gepseichert', {
          title: 'Erfolgreich',
          variant: 'success',
          solid: true,
          autoHideDelay: 5000
        })
      })
      .catch(error => {
        this.isRequestInProgress = false;
        this.modalError = {
          show: true,
          message: 'Folgender Fehler ist aufgetreten',
          error: error.response?.data?.message ?? error.message,
          title: 'Import'
        }
      });
    }
  }
}
</script>


<style>
.custom-file-input:lang(en) ~ .custom-file-label::after {
  content: 'browse';
}
.custom-file-input:lang(de) ~ .custom-file-label::after {
  content: 'durchsuchen';
}
.centered-file-input .custom-file-label {
  display: flex;
  align-items: center;
  height: 100%;
  text-align: center;
}
</style>